import { CountrySpecificitiesRule } from './CountrySpecificitiesRule';
import { DynamicUrlDTO } from './DynamicUrlDTO';

export type DynamicHrefValue = {
    href: string;
    rule: CountrySpecificitiesRule;
};

export const mapDynamicHref = (dto: DynamicUrlDTO | undefined): DynamicHrefValue | undefined => {
    if (!dto) {
        return undefined;
    }

    return {
        href: dto.url,
        rule: dto.rule,
    };
};
